import { render } from "./admissionHome.vue?vue&type=template&id=7267dd6a&scoped=true"
import script from "./admissionHome.vue?vue&type=script&lang=js"
export * from "./admissionHome.vue?vue&type=script&lang=js"

import "./admissionHome.vue?vue&type=style&index=0&id=7267dd6a&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7267dd6a"]])

export default __exports__